
<div class="d-md-flex align-items-center bg-white p-2" *ngIf="Editable">
  <div class="ml-auto mt-3 mt-md-0" >
    <button type="button" (click)="Add()" *ngIf="HasAddButton && permission.isPermitted('gestione-prodotti')" class="btn btn-cyan rounded-pill p-2" >
      <i class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
    </button>
  </div>
</div>
<app-field-viewer [(Oggetto)]="prodotto" [(Campi)]="environment.ProdottiAddOn['Ricambi'].Elements" (OnChange)="ChangeHandler($event) "></app-field-viewer>
